/**
 * @desc 查询年实际产量
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.YearRequest,
): Promise<defs.StandardReturn<defs.ObjectMap<string, number>>> {
  return defHttp.post({
    url: '/wap/plan/year/queryYearActualProduction',
    data,
  });
}

export function mock(
  data: defs.YearRequest,
): Promise<defs.StandardReturn<defs.ObjectMap<string, number>>> {
  return defHttp.post({
    url: '/mock/wap/plan/year/queryYearActualProduction',
    data,
  });
}
